/*
 * File: index.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 3, 2025 at 12:17 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 1, 2025 at 2:43 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Utilities
import { api } from '../api';

// Constants
const { PARSE_MOUNT } = process.env;


/**
 * Services
 */

export const fetchMessage = ({ slug } = {}) => api.post(`${PARSE_MOUNT}/functions/fetchMessage`, { slug });

export const fetchRelatedMessages = ({
	messageId,
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchRelatedMessages`, {
	message_id: messageId
});

export const fetchNextMessage = ({
	messageId,
	viewedMessages
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchNextMessage`, {
	message_id: messageId,
	viewed_messages: viewedMessages
});

export const fetchRandomMessage = ({
	messageId,
	viewedMessages
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchRandomMessage`, {
	message_id: messageId,
	viewed_messages: viewedMessages
});

export const fetchMessages = ({ page, limit } = {}) => api.post(`${PARSE_MOUNT}/functions/fetchMessages`, { page, limit });

export const submitMessage = ({
	content,
	submissionEmail,
	recaptchaToken
} = {}) => api.post(`${PARSE_MOUNT}/functions/submitMessage`, {
	content,
	submission_email: submissionEmail,
	recaptcha_token: recaptchaToken,
});

export const validateMessage = ({ content } = {}) => api.post(`${PARSE_MOUNT}/functions/validateMessage`, { content });
